import {authHeader} from "../helpers/auth-header";
import axios from 'axios';

const getConfigList = () => {
    return axios.get(`/api/config`, { header: authHeader() })
        .then(res => {return res.data})
};

const editConfig = (editModel) => {
    return axios.patch(`/api/config/${editModel.id}`, editModel, {headers: authHeader()})
        .then(res => {return res.data})
};

export const settingService = {
    getConfigList,
    editConfig
};
